import { BetrokkenTrein, usePatchTreinEvacuatieStatus } from "@/entities/betrokken-treinen";
import { ConfirmDialog } from "@/shared/components";

type TreinEvacuatieVerwijderenDialogProps = {
    dossierId: string;
    trein: BetrokkenTrein;
    open: boolean;
    onOpenChange: (open: boolean) => void;
};

export function TreinEvacuatieVerwijderenDialog({ dossierId, trein, open, onOpenChange }: TreinEvacuatieVerwijderenDialogProps) {
    const mutation = usePatchTreinEvacuatieStatus();

    const handleConfirm = () => {
        mutation.mutate({ dossierId, treinId: trein.id }, { onSuccess: () => onOpenChange(false) });
    };

    return (
        <ConfirmDialog
            title="Evacuatietrein verwijderen"
            isOpen={open}
            onCancel={() => {
                onOpenChange(false);
                mutation.reset();
            }}
            onConfirm={handleConfirm}
            confirmLabel="Verwijderen"
            isPending={mutation.isPending}
            destructive
            error={mutation.error}
        >
            Weet je zeker dat je de evacuatietrein wil verwijderen?
        </ConfirmDialog>
    );
}
